module.exports = __webpack_public_path__ + "static/media/close-black.f5641203.svg";